import React from 'react';
import { ShieldCheckIcon, BrainCircuitIcon, AwardIcon, HeartHandshakeIcon, ThumbsUpIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const AboutPage = () => {
  return <div className="w-full" data-id="element-272">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-24" data-id="element-273">
        <div className="absolute inset-0 bg-black opacity-60" data-id="element-274"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/sxZnRZGbG5p2zjUJbrwqXT/IMG-20250828-WA0024.jpg')",
        backgroundBlendMode: 'overlay'
      }} data-id="element-275"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-276">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-277">About Us</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-278">
            Learn about our company's journey, mission, and the values that
            drive our engineering excellence.
          </p>
        </div>
      </section>
      {/* Company Profile Section */}
      <section className="py-16" data-id="element-279">
        <div className="container mx-auto px-4" data-id="element-280">
          <div className="flex flex-col md:flex-row items-center" data-id="element-281">
            <motion.div className="md:w-1/2 mb-10 md:mb-0 md:pr-8" initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-282">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dFbZ7TfA7BeXxibRpzWd7c/IMG-20250828-WA0022.jpg" alt="Daplamba Engineering Work" className="rounded-lg shadow-lg" data-id="element-283" />
            </motion.div>
            <motion.div className="md:w-1/2" initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-284">
              <h2 className="text-3xl font-bold mb-4" data-id="element-285">
                <span className="border-b-4 border-red-600 pb-2" data-id="element-286">Company</span>{' '}
                Profile
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-287">
                Daplamba Investments Limited is a technical mechanical works
                company specializing in the installation, repair, and
                maintenance of complex engineering systems. Founded with a
                vision to deliver innovative engineering solutions, we have
                grown to become a trusted name in Uganda and across East Africa.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-288">
                Our team consists of highly qualified engineers and technicians
                with extensive experience in mechanical engineering, plumbing,
                fire safety systems, HVAC, and oil & gas installations. We
                combine technical expertise with a commitment to quality and
                safety to deliver exceptional results for our clients.
              </p>
              <p className="text-gray-700" data-id="element-289">
                We serve a diverse range of clients, from residential properties
                to large industrial facilities, providing customized solutions
                that meet their specific needs and challenges. Our reputation is
                built on reliability, professionalism, and excellence in every
                project we undertake.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Mission, Vision, Values Section */}
      <section className="py-16 bg-gray-50" data-id="element-290">
        <div className="container mx-auto px-4" data-id="element-291">
          <div className="text-center mb-12" data-id="element-292">
            <h2 className="text-3xl font-bold mb-4" data-id="element-293">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-294">Our</span>{' '}
              Mission, Vision & Values
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-295">
            <motion.div className="bg-white p-8 rounded-lg shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-296">
              <h3 className="text-2xl font-bold mb-4 text-center" data-id="element-297">
                Our Mission
              </h3>
              <p className="text-gray-700 text-center" data-id="element-298">
                To deliver innovative, safe, and reliable engineering solutions
                in plumbing, oil & gas systems, water systems, and fire safety
                that exceed our clients' expectations and contribute to the
                development of infrastructure in East Africa.
              </p>
            </motion.div>
            <motion.div className="bg-white p-8 rounded-lg shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-299">
              <h3 className="text-2xl font-bold mb-4 text-center" data-id="element-300">
                Our Vision
              </h3>
              <p className="text-gray-700 text-center" data-id="element-301">
                To be a leader in mechanical works and engineering services
                across East Africa, recognized for our technical excellence,
                innovation, and commitment to sustainable development.
              </p>
            </motion.div>
            <motion.div className="bg-white p-8 rounded-lg shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-302">
              <h3 className="text-2xl font-bold mb-4 text-center" data-id="element-303">
                Our Values
              </h3>
              <ul className="space-y-3" data-id="element-304">
                <li className="flex items-center" data-id="element-305">
                  <ShieldCheckIcon size={20} className="text-red-600 mr-2" data-id="element-306" />
                  <span className="text-gray-700" data-id="element-307">
                    <strong data-id="element-308">Safety:</strong> Prioritizing safety in all our
                    operations
                  </span>
                </li>
                <li className="flex items-center" data-id="element-309">
                  <BrainCircuitIcon size={20} className="text-red-600 mr-2" data-id="element-310" />
                  <span className="text-gray-700" data-id="element-311">
                    <strong data-id="element-312">Innovation:</strong> Embracing new technologies and
                    methods
                  </span>
                </li>
                <li className="flex items-center" data-id="element-313">
                  <HeartHandshakeIcon size={20} className="text-red-600 mr-2" data-id="element-314" />
                  <span className="text-gray-700" data-id="element-315">
                    <strong data-id="element-316">Integrity:</strong> Conducting business with honesty
                    and transparency
                  </span>
                </li>
                <li className="flex items-center" data-id="element-317">
                  <AwardIcon size={20} className="text-red-600 mr-2" data-id="element-318" />
                  <span className="text-gray-700" data-id="element-319">
                    <strong data-id="element-320">Excellence:</strong> Striving for the highest
                    quality in all we do
                  </span>
                </li>
                <li className="flex items-center" data-id="element-321">
                  <ThumbsUpIcon size={20} className="text-red-600 mr-2" data-id="element-322" />
                  <span className="text-gray-700" data-id="element-323">
                    <strong data-id="element-324">Reliability:</strong> Delivering on our promises,
                    every time
                  </span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Project Showcase Section */}
      <section className="py-16 bg-white" data-id="element-325">
        <div className="container mx-auto px-4" data-id="element-326">
          <div className="text-center mb-12" data-id="element-327">
            <h2 className="text-3xl font-bold mb-4" data-id="element-328">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-329">Our</span> Work
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-330">
              See our engineering expertise in action through these project
              highlights
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-331">
            <motion.div className="rounded-lg overflow-hidden" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} whileHover={{
            scale: 1.02
          }} data-id="element-332">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gj59xh5o8FP3M5iDrq1yB2/IMG-20250828-WA0023.jpg" alt="Infrastructure Project" className="w-full h-64 object-cover" data-id="element-333" />
              <div className="bg-gray-900 text-white p-4" data-id="element-334">
                <h3 className="text-xl font-bold" data-id="element-335">
                  Infrastructure Development
                </h3>
                <p className="text-gray-300" data-id="element-336">
                  Concrete channel construction for major facility
                </p>
              </div>
            </motion.div>
            <motion.div className="rounded-lg overflow-hidden" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} whileHover={{
            scale: 1.02
          }} data-id="element-337">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q9Rzyr8MSfeD8mb3Xz6E1b/IMG-20250828-WA0026.jpg" alt="Indoor Installation Work" className="w-full h-64 object-cover" data-id="element-338" />
              <div className="bg-gray-900 text-white p-4" data-id="element-339">
                <h3 className="text-xl font-bold" data-id="element-340">
                  Industrial Facility Installation
                </h3>
                <p className="text-gray-300" data-id="element-341">
                  Technical installation in commercial building
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Team Section */}
      <section className="py-16 bg-gray-50" data-id="element-342">
        <div className="container mx-auto px-4" data-id="element-343">
          <div className="text-center mb-12" data-id="element-344">
            <h2 className="text-3xl font-bold mb-4" data-id="element-345">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-346">Our</span> Expert
              Team
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-347">
              Our success is driven by our team of highly qualified
              professionals who bring expertise, passion, and dedication to
              every project.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-348">
            {/* Team members would go here - using placeholders */}
            <motion.div className="bg-white rounded-lg overflow-hidden shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} whileHover={{
            y: -10
          }} data-id="element-349">
              <div className="h-64 bg-gray-300" data-id="element-350"></div>
              <div className="p-6 text-center" data-id="element-351">
                <h3 className="text-xl font-bold" data-id="element-352">John Doe</h3>
                <p className="text-gray-600" data-id="element-353">Chief Engineer</p>
              </div>
            </motion.div>
            <motion.div className="bg-white rounded-lg overflow-hidden shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} whileHover={{
            y: -10
          }} data-id="element-354">
              <div className="h-64 bg-gray-300" data-id="element-355"></div>
              <div className="p-6 text-center" data-id="element-356">
                <h3 className="text-xl font-bold" data-id="element-357">Jane Smith</h3>
                <p className="text-gray-600" data-id="element-358">Operations Director</p>
              </div>
            </motion.div>
            <motion.div className="bg-white rounded-lg overflow-hidden shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} whileHover={{
            y: -10
          }} data-id="element-359">
              <div className="h-64 bg-gray-300" data-id="element-360"></div>
              <div className="p-6 text-center" data-id="element-361">
                <h3 className="text-xl font-bold" data-id="element-362">Michael Johnson</h3>
                <p className="text-gray-600" data-id="element-363">Technical Manager</p>
              </div>
            </motion.div>
            <motion.div className="bg-white rounded-lg overflow-hidden shadow-lg" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} whileHover={{
            y: -10
          }} data-id="element-364">
              <div className="h-64 bg-gray-300" data-id="element-365"></div>
              <div className="p-6 text-center" data-id="element-366">
                <h3 className="text-xl font-bold" data-id="element-367">Sarah Williams</h3>
                <p className="text-gray-600" data-id="element-368">Project Coordinator</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-red-600 text-white" data-id="element-369">
        <div className="container mx-auto px-4 text-center" data-id="element-370">
          <h2 className="text-3xl font-bold mb-6" data-id="element-371">
            Ready to Work with Our Team?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-372">
            Contact us today to discuss how our experienced professionals can
            help with your engineering and mechanical needs.
          </p>
          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-373">
            <a href="/contact" className="bg-white text-red-600 hover:bg-gray-100 px-8 py-3 rounded-md font-medium transition-colors inline-block" data-id="element-374">
              Get in Touch
            </a>
          </motion.div>
        </div>
      </section>
    </div>;
};
export default AboutPage;